@if (isLoading()) {
  <app-dots-loader></app-dots-loader>
} @else {
  <app-nav-header></app-nav-header>
  <div class="hero-section">
    <div class="cover">
      <img src="assets/images/tech-stack.jpg"/>
    </div>
    <div class="info-section">
      <h1>Our tech <span>stack</span></h1>
      <div class="stack-description">
        Using advanced tools and technologies, we deliver software solutions that are reliable,
        efficient, and future-ready.
      </div>
    </div>
    <div class="animation-wrapper">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
    </div>
  </div>
  <div class="tech-stack-container">
    <!--  <h2>-->
    <!--    The core technologies and frameworks we use-->
    <!--  </h2>-->
    <div class="flex-column">
      @for (stack of technologies(); track stack) {
        <div class="flex-row-wrap">
          <div class="line"></div>
          <h2 class="stack-title">
            {{ getStackLabel(stack.stack) }}
          </h2>
          <div class="stack-container">
            @for (tech of stack.items; track tech.id) {
              <div class="tech">
                <img [src]="tech?.foto?.url" height="60"/>
                <span>{{ tech.name }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <app-footer></app-footer>
}
